import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { WindowType } from '../../../../util';
import { Board, ListItem } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

declare var window: WindowType;

@Component({ name: 'ShareBoardModal' })
export default class ShareBoardModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    board!: Board;
    @Prop({ required: true })
    sharedWith!: string[];

    //
    private filter: string = '';

    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private get available(): ListItem[] {
        let ex = this.sharedWith.map(e => e);
        ex.push(window.application.kanban.user?.id!); //current user
        return this.state.users.filter(e => !ex.includes(e.id!));
    }

    private get alreadySharedWith(): ListItem[] {
        let incl = this.sharedWith.map(e => e);
        return this.state.users.filter(e => incl.includes(e.id!));
    }

    private get availableFiltered(): ListItem[] {
        return this.available
            .filter(u => !this.filter?.trim().length || (u.firstName + ' ' + u.lastName).toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
            .sort((a,b) => (a.firstName + ' ' + a.lastName).toLocaleLowerCase().localeCompare((b.firstName + ' ' + b.lastName).toLocaleLowerCase()));
    }
    
    private get alreadySharedWithFiltered(): ListItem[] {
        return this.alreadySharedWith
            .filter(r => !this.filter?.trim().length || (r.firstName + ' ' + r.lastName).toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
            .sort((a,b) => (a.firstName + ' ' + a.lastName).toLocaleLowerCase().localeCompare((b.firstName + ' ' + b.lastName).toLocaleLowerCase()));
    }

    private add(user: ListItem): void {
        this.$emit('addBoardShared', { user: user, board: this.board });
    }

    private remove(user: ListItem): void {
        this.$emit('removeBoardShared', { user: user, board: this.board });
    }

    close(): void {

    }
}